export const env = {
  api_url: import.meta.env.VITE_API_URL,
  client_id: import.meta.env.VITE_CLIENT_ID,
  client_secret: import.meta.env.VITE_CLIENT_SECRET,
  web_vitals: Boolean(import.meta.env.VITE_WEB_VITALS),
  disable_desktop_attendance: import.meta.env.VITE_FEATURE_DESKTOP_ATTENDANCE === '0',
};
